import React, { useContext, useState } from "react";
import { StoreContext } from "../../../../storeroom/StoreContext";
import { deepCopy } from "../../../../utils";
import { useObserver } from "mobx-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core";

interface Props {
  show: boolean;
  onClose: () => void;
}

export default function ListingDescriptionForm(props: Props) {
  const store = useContext(StoreContext);
  const listing = store.listingStore.listing;

  const [pending, setPending] = useState(false);
  const [description, setDescription] = useState(listing.description);

  const onChange = (event: any) => {
    setDescription(event.target.value);
  };

  const onSubmit = (event: any) => {
    event.preventDefault();
    setPending(true);

    const updatedListing = deepCopy(listing);
    updatedListing.description = description;

    store.listingStore
      .update(updatedListing)
      .then(() => props.onClose())
      .catch(() => setPending(false));
  };

  return useObserver(() => (
    <Dialog open={props.show} maxWidth={"md"} fullWidth={true}>
      <form onSubmit={onSubmit} autoComplete={"off"}>
        <DialogTitle>Description</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Describe the living space of your home. Include extra amenities like
            kitchen facilities, home gym, office space, etc.
          </DialogContentText>

          <div style={{ height: "2em" }} />

          <TextField
            label={"Description"}
            fullWidth
            defaultValue={description}
            onChange={onChange}
            multiline
            rows={18}
          />
        </DialogContent>

        <DialogActions style={{ marginTop: "1em" }}>
          <Button onClick={props.onClose} disabled={pending}>
            Cancel
          </Button>
          <Button
            type={"submit"}
            variant={"contained"}
            color={"primary"}
            disabled={pending}
          >
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  ));
}
